module.exports = __webpack_public_path__ + "static/author-79a74c2f2707dc87691d4cde0aaf6fc5.jpg";